module.exports = __webpack_public_path__ + "img/6.5ebd82f3.jpg";